import { useQuery } from "@tanstack/react-query"
import { getSellerLeadContact } from "@/lib/api/seller-leads.api"
import { useAuthStore } from "@/store/auth.store"

export function useGetSellerLeadContact(id: string | null, enabled = false) {
  const { accessToken } = useAuthStore()

  return useQuery({
    queryKey: ["seller-lead-contact", id],
    queryFn: async () => {
      if (!accessToken || !id) throw new Error("Not authenticated or missing id")
      const response = await getSellerLeadContact(id, accessToken)
      return response.data
    },
    enabled: !!accessToken && !!id && enabled,
  })
}
